import PdfIcon from 'components/Icons/pdfIcon';
import WordIcon from 'components/Icons/wordIcon';
import ExcelIcon from 'components/Icons/excelIcon';
import PptIcon from 'components/Icons/pptIcon';
import VideoIcon from 'components/Icons/videoIcon';
import ImageIcon from 'components/Icons/imageIcon';
import ZipIcon from 'components/FileIcon/icons/ZipIcon';

export const FILE_TYPES = {
  pdf: {
    icon: PdfIcon,
    styles: {
      width: 20,
      height: 20,
      color: 'white',
    },
    bgColor: '#E53935',
  },
  word: {
    icon: WordIcon,
    styles: {
      width: 20,
      height: 20,
      color: 'white',
    },
    bgColor: '#1E88E5',
  },
  excel: {
    icon: ExcelIcon,
    styles: {
      width: 20,
      height: 20,
      color: 'white',
    },
    bgColor: '#43A047',
  },
  ppt: {
    icon: PptIcon,
    styles: {
      width: 20,
      height: 20,
      color: 'white',
    },
    bgColor: '#F4511E',
  },
  video: {
    icon: VideoIcon,
    styles: {
      width: 20,
      height: 20,
      color: 'white',
    },
    bgColor: '#D81B60',
  },
  image: {
    icon: ImageIcon,
    styles: {
      width: 20,
      height: 20,
      color: 'white',
      '& path': {
        fill: 'white',
      },
    },
    bgColor: '#00ACC1',
  },
  archive: {
    icon: ZipIcon,
    styles: {
      width: 20,
      height: 20,
      color: 'white',
      '& path': {
        fill: 'white',
      },
    },
    bgColor: '#00ACC1',
  },
};
